import React from 'react'
import { SRLWrapper } from "simple-react-lightbox";
import {Helmet} from 'react-helmet';


export default function Matkailuauto() {
    return (
        <>
        <Helmet>
                <title>Matkailuauton vuokraus | Kirppis Ruusunen</title>
                <meta name="robots" content="index, archive"/>
                <meta name="description" content="Vuokrataan matkailuauto Sunlight t64, vuosimalli 2018. 100€/vrk, 590€/vko."/>
         </Helmet>
            <SRLWrapper>
            <div className="galleria mb-1">
                <div className="row">
                    <div className="p-1 p-md-3  p-lg-2 text-white col-lg-5">
                        <div className="matkailu px-3 pt-1 pb-3">
                            <h2 className="pt-3 pb-3 pb-lg-4 text-center">Vuokrataan matkailuauto</h2>
                            <div className="m-tausta pt-3 pt-lg-4">
                                <h4 className="text-center pb-1">Sunlight T68 Adventure Edition</h4>
                                
                                <div className="p-2">
                                    <h5 className="text-center mb-3 mb-sm-1">Varusteet</h5>
                                    <p className="mb-5 mb-sm-3"><b>Turvallisuus:</b> ABS-jarrut, Airbag <br/> 
                                    <b>Sisätilat ja mukavuudet: </b> Ohjaustehostin, Sähkökäyttöiset ikkunat, Vakionopeudensäädin, Ajotietokone, Sähköpeilit, Kasetti WC, Suihku, Lämminvesiboileri, Liesi, Jääkaappi, Pakastelokero, Pesuallas, Keskuslukitus: Kaukosäätöinen, Ilmastointi: Manuaalinen
                                    <br/> <b>Muut: </b>
                                    Kattoluukku, Turbo, Trumatic, Eristetty harmaavesisäiliö, Lattialämmitys, Sähköpatruuna, Erillisvuoteet</p>
                                    <h5 className="text-center  mb-3 mb-sm-1">Tekniset tiedot</h5>
                                    <p className="mb-5 mb-sm-3">Teho: <b>103 kW / 140 Hv</b>, Pituus: <b>7,40 m</b>, Leveys: <b>2,32 m</b>, Vuodepaikkoja: <b>5</b>, Henkilömäärä: <b>5</b> </p>
                                    <h5 className="text-center  mb-3 mb-sm-1">Lisätiedot</h5>
                                    <p className="mb-5 mb-sm-3">Truma Combi 6E, lattialämmitys, lämminvesi, ohjaamoilmastointi, eristetty harmaavesisäiliä, laskuvuode, iso jääkaappi, erillisvuoteet yhdistämismahdollisuudella. 140hv, automaatti, rek. 5-hengelle, Adventure Edition varusteet.

Lisäksi Zenec-multimediasoitin navilla ja peruutuskameralla.</p>
                                </div>

                                <section className="row text-center m-auto mb-2">

                                    <div className="col-12 pt-4 pb-2 matkailuboxi">
                                    <p><b>KESÄ- ELOKUU</b> <br />
                                    1200€/vko sis. 2100km </p>
                                    </div>

                                    <div className="col-12 pb-2">
                                    <p><b>Kevät- ja syysviikot</b> <br />
                                    990€/vko sis. 2100km</p>
                                    </div>
                                    <br />
                                    <h5>Ei talvivuokrausta</h5>
                                    <h5 className="pb-2 text-center">Varaukset: Marko Kantola </h5>
                                    <h5><span className="puh_nro py-1 px-2">Puh: 044 5555 253 <span className="fas fa-phone"></span></span></h5>

                                </section>
                            </div>
                        </div>    
                        
                    </div>

                    
                        <div className="col-12 col-lg-7">
                            <div className="row">
                                <img className="img-fluid col-12 col-sm-6" alt="matkailuauto1" src={require("../img/matkailuautokuvat/matkailuauto.jpg").default}></img>
                                <img className="img-fluid col-6 col-sm-6" alt="matkailuauto2" src={require("../img/matkailuautokuvat/IMG_9772.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-6" alt="matkailuauto3" src={require("../img/matkailuautokuvat/sisakuvaratti.jpg").default}></img>
                                <img className="img-fluid col-6 col-sm-6" alt="matkailuauto4" src={require("../img/matkailuautokuvat/IMG_9770.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto5" src={require("../img/matkailuautokuvat/ulkokuva1.jpg").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto6" src={require("../img/matkailuautokuvat/ulkokuvasisa.jpg").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto7" src={require("../img/matkailuautokuvat/IMG_9771.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto8" src={require("../img/matkailuautokuvat/IMG_9772.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto9" src={require("../img/matkailuautokuvat/IMG_9773.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto10" src={require("../img/matkailuautokuvat/IMG_9774.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto11" src={require("../img/matkailuautokuvat/IMG_9775.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-3" alt="matkailuauto12" src={require("../img/matkailuautokuvat/IMG_9779.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-4" alt="matkailuauto13" src={require("../img/matkailuautokuvat/IMG_9781.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-4" alt="matkailuauto14" src={require("../img/matkailuautokuvat/vaaka1.JPG").default}></img>
                                <img className="img-fluid col-6 col-sm-4" alt="matkailuauto15" src={require("../img/matkailuautokuvat/vaaka2.JPG").default}></img>
                            </div>
                        </div>
                    
                </div>
                
            </div>
            </SRLWrapper>
        </>
    )
}
